import { render, staticRenderFns } from "./FluxEditor.vue?vue&type=template&id=6fa535dd&"
import script from "./FluxEditor.vue?vue&type=script&lang=js&"
export * from "./FluxEditor.vue?vue&type=script&lang=js&"
import style0 from "./FluxEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports